import { useEffect, useState } from "react";

// Internal Imports
import { useAuth } from "../contexts/auth";
import { IAttribute } from "../interfaces/IAttribute";
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import { GetAttributesByUserID } from "../services/attribute";


const useListAttribute = () => {

    // States
    const { user } = useAuth();
    const [listAttribute, setListAttribute] = useState<IAttribute[]>([]);
    const [loadingAttr, setLoadingAttr] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetAttributesByUserID();
    }, [user])

    // Handles
    const handleGetAttributesByUserID = () => {
        setLoadingAttr(true);
        tryCatch(() => {
            if (!!user) {
                GetAttributesByUserID(user.usuarioID)
                    .then((response) => {
                        setListAttribute(response.data);
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setLoadingAttr(false));
            }
        })
    }

    return {
        listAttribute,
        setListAttribute,
        loadingAttr,
    }
}


export default useListAttribute;
